var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7966 5.37558H4.47232V6.0513H3.7966V5.37558ZM3.7966 2.6727H4.47232V4.69986H3.7966V2.6727ZM4.13446 0.983398C2.26609 0.983398 0.755859 2.50377 0.755859 4.362C0.755859 5.25806 1.11182 6.11742 1.74543 6.75103C2.05916 7.06476 2.43161 7.31363 2.84153 7.48342C3.25144 7.65321 3.69078 7.7406 4.13446 7.7406C5.03052 7.7406 5.88988 7.38464 6.52349 6.75103C7.1571 6.11742 7.51306 5.25806 7.51306 4.362C7.51306 3.91831 7.42567 3.47898 7.25588 3.06906C7.08609 2.65915 6.83722 2.2867 6.52349 1.97297C6.20976 1.65924 5.83731 1.41037 5.42739 1.24058C5.01748 1.07079 4.57814 0.983398 4.13446 0.983398ZM4.13446 7.06488C3.41761 7.06488 2.73012 6.78011 2.22324 6.27322C1.71635 5.76634 1.43158 5.07885 1.43158 4.362C1.43158 3.64515 1.71635 2.95766 2.22324 2.45077C2.73012 1.94389 3.41761 1.65912 4.13446 1.65912C4.85131 1.65912 5.5388 1.94389 6.04569 2.45077C6.55257 2.95766 6.83734 3.64515 6.83734 4.362C6.83734 5.07885 6.55257 5.76634 6.04569 6.27322C5.5388 6.78011 4.85131 7.06488 4.13446 7.06488Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamination);
export default __webpack_public_path__ + "static/media/exclamination.9b39ede8.svg";
export { ForwardRef as ReactComponent };